/*
  "Personal message" line item property.

  Product blocks are rendered outside the add-to-cart <form>, so a
  `properties[...]` field only reaches the cart if the browser treats it as part
  of that form. The Liquid markup does this with the HTML `form` attribute; this
  file re-applies it at runtime as a safety net (for example when the field is
  added through a Custom liquid block or a theme block, which cannot output the
  form id themselves).

  It also handles the character counter, the optional "message required" rule,
  and stops an empty message from being sent as a blank property.
*/

(function personalMessage() {
  const MESSAGE_FIELD = '[data-personal-message-field]';
  const OWNED_FIELD = '[data-personal-message-field], [data-personal-message-bound]';
  const PROPERTY_FIELD = 'textarea[name^="properties["], input[name^="properties["], select[name^="properties["]';
  const ADD_TO_CART_FORM = 'form[data-type="add-to-cart-form"]';

  function addToCartFormFor(field) {
    const scope = field.closest('product-info, .product, .shopify-section');
    return (scope && scope.querySelector(ADD_TO_CART_FORM)) || document.querySelector(ADD_TO_CART_FORM);
  }

  // A field whose `form` property is null is not submitted with the cart request.
  function bindToForm(field) {
    if (field.form) return;

    const form = addToCartFormFor(field);
    if (!form) return;

    // `form.id` would return the <input name="id"> control - named form
    // controls shadow the element's own properties - so read the attribute.
    const formId = form.getAttribute('id');
    if (!formId) return;

    field.setAttribute('form', formId);
    // Marks the fields we had to rescue, so the empty-value handling below
    // applies to them too - but never to fields the theme puts in the form
    // itself, such as the gift card recipient fields.
    field.dataset.personalMessageBound = 'true';
  }

  function setupCounter(field) {
    if (field.dataset.counterReady === 'true') return;

    const counter = field.dataset.counterTarget ? document.getElementById(field.dataset.counterTarget) : null;
    if (!counter) return;

    field.dataset.counterReady = 'true';
    const render = () => {
      counter.textContent = field.value.length;
    };

    field.addEventListener('input', render);
    render();
  }

  function errorElementFor(field) {
    const wrapper = field.closest('.product-personal-message');
    return wrapper ? wrapper.querySelector('[data-personal-message-error]') : null;
  }

  function setError(field, hasError) {
    const wrapper = field.closest('.product-personal-message');
    if (wrapper) wrapper.classList.toggle('product-personal-message--error', hasError);

    const error = errorElementFor(field);
    if (error) error.hidden = !hasError;

    field.setAttribute('aria-invalid', hasError ? 'true' : 'false');
  }

  function clearErrorOnInput(field) {
    if (field.dataset.errorReady === 'true') return;
    field.dataset.errorReady = 'true';

    field.addEventListener('input', () => {
      if (field.value.trim() !== '') setError(field, false);
    });
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

      const fields = Array.from(document.querySelectorAll(OWNED_FIELD)).filter((field) => field.form === form);
      if (fields.length === 0) return;

      let firstInvalid = null;
      const emptied = [];

      fields.forEach((field) => {
        const value = field.value.trim();
        if (value !== field.value) field.value = value;

        if (value === '') {
          if (field.dataset.required === 'true') {
            if (!firstInvalid) firstInvalid = field;
          } else {
            // Disabled fields are skipped by FormData, so no blank property is
            // sent. Re-enabled on the next tick, after the theme has read the form.
            field.disabled = true;
            emptied.push(field);
          }
        } else {
          setError(field, false);
        }
      });

      if (firstInvalid) {
        // Capture phase, so this stops the theme's own submit handler running.
        event.preventDefault();
        event.stopPropagation();

        emptied.forEach((field) => {
          field.disabled = false;
        });

        setError(firstInvalid, true);
        firstInvalid.focus();
        return;
      }

      if (emptied.length > 0) {
        window.setTimeout(() => {
          emptied.forEach((field) => {
            field.disabled = false;
          });
        }, 0);
      }
    },
    true
  );

  function init(root) {
    const scope = root || document;

    scope.querySelectorAll(PROPERTY_FIELD).forEach(bindToForm);
    scope.querySelectorAll(MESSAGE_FIELD).forEach((field) => {
      setupCounter(field);
      clearErrorOnInput(field);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (!data || data.source !== 'product-form') return;

      document.querySelectorAll(MESSAGE_FIELD).forEach((field) => {
        if (field.dataset.clearAfterAdd !== 'true') return;
        if (field.value === '') return;

        field.value = '';
        field.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  }
})();
